import { render, staticRenderFns } from "./CompanyList.vue?vue&type=template&id=957959c8&scoped=true&"
import script from "./CompanyList.vue?vue&type=script&lang=ts&"
export * from "./CompanyList.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyList.vue?vue&type=style&index=0&id=957959c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "957959c8",
  null
  
)

export default component.exports